$(document).ready(function() {

	//toggleMap calls
	$(".csp_toggleMap").click(function() {
		toggleMap($(this).data('togglemap'));
	});
	
	//clickKey calls
	$(".csp_clickKey").click(function() {
		if ($(this).attr('data-clickkeysite')) {
			clickFrameKey($(this).data('clickkeysite'), $(this).data('clickkey'), this.parentNode);
		} else {
			clickKey($(this).data('clickkey'), this.parentNode);
		}
	});

	// event delegation because the infinite scrolling adds more 'share icons' after initial page load
	$('body').on('click', '.csp_promptShareLink', function () {
		var items = [ $(this).data('promptsharelink1') ];
		promptShareLink( items, $(this).data('promptsharelink2'));
	});
	
	//showItem on the map
	$(".csp_showItem").click(function(event) {
		showItem($(this).data('showitem'));
	});
	
	//changenewmail calls
	$(".csp_changenewmail").on("keypress", function() {
		changenewmail(0);
	}).on("paste", function() {
		changenewmail(0);
	});
	
	//toggleCollapse calls
	$(".csp_toggleCollapse").click(function(event) {
		toggleCollapse($(this).data('togglecollapse'));
	});
	
	//Live menu csp
	$(document).on('click','.csp_showFilterPersonal',function() {
		showFilterFormPersonal();
	});
	$(document).on('click','.csp_showFilterForm',function() {
		showFilterForm();
	});
});

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
